export const HOME_PAGE_EVENTS = {
  PAGELOAD: 'home_page_loads',
};
